import type { MutationFunction } from '@ztechapps/common.hook'
import { useError, useHistory, useMutation } from '@ztechapps/common.hook'
import { logisticQueries } from '@ztechapps/logistic.common'
import { routesDef } from '../config/routes'
import type { ApolloError } from '@apollo/client/errors'
import type { Logistic } from '@ztechapps/common.contract'

type UseAddLogisticResult = {
  onAddLogistic: (input?: Logistic) => Promise<void>
  error: ApolloError
  loading: boolean
  onAddRawLogistics: MutationFunction<
    {
      createLogistic: Logistic
    },
    Logistic
  >
}
export const useAddLogistic = (): UseAddLogisticResult => {
  const [onAdd, , { error, loading }] = useMutation<{ createLogistic: Logistic }, Logistic>({
    ...logisticQueries.createConfig,
  })

  const { onError } = useError()
  const history = useHistory()

  const onAddLogistic = async (input?: Logistic) => {
    try {
      input = input || ({} as Logistic)
      const { data, errors } = await onAdd({ input })
      if (errors) throw errors

      const { _id } = data?.createLogistic ?? {}

      return history.push(routesDef.LogisticItemPage.altPath({ _id }))
    } catch (e) {
      onError(e)
    }
  }

  return { onAddLogistic, error, loading, onAddRawLogistics: onAdd }
}
